import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import FirearmPurposeForm from '../../../components/forms/FirearmPurposeForm';
import { useFirearmPurposeById, useUpdateFirearmPurpose } from '../../../hooks/useFirearmPurposeApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { FirearmPurposeDTO } from '../../../services/apiClient';

const FirearmPurposeEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useFirearmPurposeById(id!);
  const updateFirearmPurpose = useUpdateFirearmPurpose();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Firearm Purposes', href: '/admin/firearmpurposes' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateFirearmPurpose.mutateAsync({ id: id!, data });
      navigate('/admin/firearmpurposes');
    } catch (error) {
      console.error('Error updating FirearmPurpose:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/firearmpurposes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.FirearmPurpose.Edit'
    >
        {entityData ? (
          <FirearmPurposeForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/firearmpurposes')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default FirearmPurposeEdit;